import React, { useState } from 'react';
import { Button } from 'antd';
import { CodeOutlined } from '@ant-design/icons';
import { EmailHtmlModal } from './EmailHtmlModal';

interface EmailBodyData {
  html: string;
  text: string;
  contentType: string;
}

interface EmailBodyRendererProps {
  emailBody: EmailBodyData | string;
  emailSubject?: string;
  compact?: boolean;
}

export const EmailBodyRenderer: React.FC<EmailBodyRendererProps> = ({
  emailBody,
  emailSubject,
  compact = false
}) => {
  const [showHtmlModal, setShowHtmlModal] = useState(false);

  // Handle both old string format and new object format for backwards compatibility
  const isNewFormat = typeof emailBody === 'object' && emailBody !== null;
  const htmlContent = isNewFormat ? emailBody.html : emailBody;
  const textContent = isNewFormat ? emailBody.text : emailBody;
  const hasHtmlContent = isNewFormat && emailBody.html && emailBody.html.trim().length > 0;

  return (
    <div>
      {/* Plain text content */}
      <div style={{ 
        whiteSpace: 'pre-wrap',
        fontFamily: 'inherit',
        lineHeight: compact ? '1.4' : '1.6',
        fontSize: compact ? '13px' : 'inherit'
      }}>
        {textContent}
      </div>
      
      {/* HTML View Button - only show if we have HTML content that's different from text */}
      {hasHtmlContent && (
        <div style={{ 
          marginTop: '12px',
          borderTop: '1px solid #f0f0f0',
          paddingTop: '8px'
        }}>
          <Button
            size="small"
            icon={<CodeOutlined />}
            onClick={() => setShowHtmlModal(true)}
            style={{ fontSize: '12px' }}
          >
            View HTML
          </Button>
        </div>
      )}
      
      {/* HTML Modal */}
      {hasHtmlContent && (
        <EmailHtmlModal
          visible={showHtmlModal}
          onClose={() => setShowHtmlModal(false)}
          htmlContent={htmlContent}
          emailSubject={emailSubject}
        />
      )}
    </div>
  );
};